module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("thankyou", [["div",{"class":"one-col-emulator thankyou-page"},[["div",{"class":"page-404"},[["h2",{},[["textNode",{"text":"Thank you for order!"}]]],["div",{"class":"links"},[["a",{"href":"#","id":"previous-page"},[["textNode",{"text":"Go to previous page"}]]],["textNode",{"text":" "}],["span",{"class":"bullet"},[["textNode",{"text":"•"}]]],["textNode",{"text":" "}],["a",{"href":"#","id":"main-page"},[["textNode",{"text":"Go to main page"}]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!../common/templates/thankyou.tpl
// module id = 462
// module chunks = 2